import React, { useEffect, useContext } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Helmet } from 'react-helmet';
import { AppContext } from './AppContext'; // ✅ as per your specified path

import Header from './Header';
import Footer from './Footer';

export default function TermsAndConditions() {
    const { settings } = useContext(AppContext);
    const brandName = settings?.brandName || '';

    useEffect(() => {
        AOS.init({ once: true });
    }, []);

    return (
        <>
            <Helmet>
                <title>Terms & Conditions | {brandName}</title>
                <meta
                    name="description"
                    content={`Read the Terms and Conditions of ${brandName}`}
                />
            </Helmet>

            <Header />

            <main
                className="p-6 lg:p-16 max-w-4xl mx-auto text-center"
                data-aos="fade-up"
            >
                <h1 className="text-4xl font-bold mb-6">Terms & Conditions</h1>
                <p className="text-base text-gray-700 leading-relaxed">
                    Here are the Terms and Conditions for {brandName}.
                </p>
            </main>

            <Footer />
        </>
    );
}
